<template>
    <div 
        v-if="visible"
        class="award-dialog-mask"
        @click="closeMask">
        <div class="content-box">
            <template v-if="is_record">
                <div 
                    class="award-dialog-record" 
                    @click="stopBubbling">
                    <p class="title">{{ is_unassigned_award ? '手动领取' : '中奖记录' }}</p>
                    <div
                        v-if="!is_unassigned_award"
                        class="record-list">
                        <template v-if="record_list.length>0">
                            <div 
                                v-for="(item, index) in record_list" 
                                :key="index"
                                class="record-line">
                                <div class="award-name">{{ item.award_title }}</div>
                                <div class="award-time">{{ item.award_time?formatTime(item.award_time):'-' }}</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="no-data">你还没有抽中奖品～</div>
                        </template>
                    </div>
                    <template v-else>
                        <div class="receive-list">
                            <div class="receive-line">{{ unassigned_text }}</div>
                            <template v-for="(item, index) in record_list">
                                <div
                                    v-if="index<2"
                                    :key="index"
                                    class="receive-line"
                                >{{ item.award_title }}</div>
                            </template>
                        </div>
                        <div
                            class="assign-button"
                            @click="toReceiveCenter">去领取</div>
                    </template>
                    <div 
                        class="close" 
                        @click="closeMask"/>
                </div>
            </template>
            <template v-else>
                <div 
                    class="award-dialog-other" 
                    @click="stopBubbling">
                    <p class="title">恭喜抽中</p>
                    <div class="award-name">{{ stop_award.award_title }}</div>
                    <div
                        v-if="stop_award.message_award_expire"
                        class="award-desc">{{ stop_award.message_award_expire }}</div>
                    <div 
                        class="confirm-btn" 
                        @click="confirmAward">{{ btnText }}</div>
                    <div
                        class="close" 
                        @click="closeMask"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { forward } from "@kk/h5-sdk";
import { miniNav, qs } from "@kkmh/utils";
// import { switch_page } from "@kk/h5-sdk";
// import { ua } from "@kkmh/utils";

export default {
    name: "AwardDialog",
    props: {
        is_record: {
            type: Boolean,
            default: true,
        },
        visible: {
            type: Boolean,
            default: false
        },
        stop_award: {
            type: Object,
            default: function(){
                return {};
            }
        },
        record_list: {
            type: Array,
            default: function(){
                return [];
            }
        },
        is_unassigned_award: {
            type: Boolean,
            default: false,
        },
        unassigned_text: {
            type: String,
            default: "",
        }
    },
    data(){
        return{
            showDialog: false,
            ua: window.__gvalkkmh ? window.__gvalkkmh.ua : {},
        };
    },
    computed: {
        btnText(){
            if(JSON.stringify(this.stop_award)!="{}"&&this.stop_award.award_url){
                return "去领取";
            } else {
                return "开心收下";
            }
        }
    },
    watch: {
        visible(){
            this.showDialog = this.visible;
        }
    },
    created(){
        this.showDialog = this.visible;
    },
    methods: {
        // 关闭弹窗
        closeMask() {
            this.$emit("closeDialog");
        },
        // 阻止事件冒泡
        stopBubbling(event){
            event.stopPropagation();
        },
        //格式化时间
        formatTime(timestamp) {
            let time = new Date(timestamp);
            let y = time.getFullYear();
            let m = (time.getMonth() + 1)>9?(time.getMonth() + 1):"0"+(time.getMonth() + 1);
            let d = time.getDate()>9?time.getDate():"0"+time.getDate();
            let h = time.getHours()>9?time.getHours():"0"+time.getHours();
            let min = time.getMinutes()>9?time.getMinutes():"0"+time.getMinutes();
            // let s = time.getSeconds()>9?time.getSeconds():"0"+time.getSeconds();
            return `${y}/${m}/${d} ${h}:${min}`;
        },
        // confirmAward
        confirmAward(){
            if(this.stop_award.award_url) {
                forward({
                    totype: "h5",
                    topage: this.stop_award.award_url,
                    todata: {},
                });
            }
            this.$emit("closeDialog");
        },
        // 去领取中心页面
        toReceiveCenter() {
            let TRIGGER_PAGE = qs["orign"] || "";
            let url = `${location.origin}/native_pay_vip_link_vip_multiple_list.html?conf2fullscreen=1&conf2scrollwhitearea=1&statusbar=0&origin=${TRIGGER_PAGE}`;
            if (this.ua.kkmh) {
                forward({
                    totype: "h5",
                    topage: url,
                    todata: {},
                });
            }else if (this.ua.miniprogram){
                miniNav("/pages/webview/webview?url=" + encodeURIComponent(url+"&refresh=true&type=2003"));// refresh参数为小程序中的页面提供刷新能力
            } else {
                location.href = url;
            }
            this.$emit("closeDialog");
        },
    }
};
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/vws.scss';
    .award-dialog-mask{
        position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, .85);
        z-index: 12;
        .content-box{
            position: absolute;
            left: 50%;
            top: 50%;
            transform:translate(-50%, -50%);
        }
        .award-dialog-record{
            width: vws(640px);
            min-height: vws(246px);
            border-radius: vws(24px);
            background: #fff;
            text-align: center;
            margin-top: vws(-100px);
            padding-bottom: vws(40px);
            .title{
                padding: vws(40px) 0 vws(20px);
                font-size: vws(40px);
                font-weight: 500;
                color: #333333;
            }
            .record-list{
                padding: 0 vws(37px) ;
                max-height: vws(400px);
                // margin-bottom: vws(40px);
                overflow-y: scroll;
                color: #989898;
                .record-line{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: vws(24px);
                    padding: vws(18px) 0;
                    line-height: 1;
                    .award-name{
                        color: #666;
                        width: 50%;
                        text-align: left;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .award-time{
                        width: 49%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .no-data{
                    font-size: vws(28px);
                }
            }
            .receive-list {
                padding: 0 vws(37px);
                .receive-line{
                    font-size: vws(30px);
                    padding: vws(8px) 0;
                    color: #FF7A46;
                    line-height: 1;
                    &:first-child {
                        color: #666;
                    }
                }
            }
            .assign-button {
                margin: 0 auto;
                margin-top: vws(40px);
                width: vws(470px);
                height: vws(84px);
                line-height: vws(84px);
                border-radius: vws(42px);
                background: #FCE04E;
                font-size: vws(30px);
                font-weight: 500;
                color: #4A2525;
            }
            .close {
                position: absolute;
                bottom: vws(-103px);
                left: vws(291px);
                width: vws(58px);
                height: vws(58px);
                background: url(data:image/png;base64,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) center center no-repeat;
                background-size: 100% 100%;

            }
        }
        .award-dialog-other{
            width: vws(560px);
            border-radius: vws(24px);
            background: #fff;
            text-align: center;
            padding-bottom: vws(28px);
            .title{
                padding: vws(50px) 0 vws(20px);
                font-size: vws(40px);
                font-weight: 500;
            }
            .award-name {
                width: 90%;
                margin: 0 auto;
                font-size: vws(30px);
                color: #FF7A46;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .award-desc {
                width: 90%;
                margin: 0 auto;
                font-size: vws(22px);
                font-weight: 300;
                color: #989898;
            }
            .confirm-btn{
                margin: 0 auto;
                margin-top: vws(40px);
                width: vws(470px);
                height: vws(84px);
                line-height: vws(84px);
                border-radius: vws(42px);
                background: #FCE04E;
                font-size: vws(30px);
                font-weight: 500;
                color: #4A2525;
            }
            .close {
                position: absolute;
                bottom: vws(-103px);
                left: vws(251px);
                width: vws(58px);
                height: vws(58px);
                background: url(data:image/png;base64,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) center center no-repeat;
                background-size: 100% 100%;

            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/native/pay/vip/link_vip_multiple/comp/AwardDialog.vue